"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioCard = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const input_styles_1 = require("@/components/common/input/input.styles");
const radio_styles_1 = require("@/components/common/radio/radio.styles");
const radio_utils_1 = require("@/components/common/radio/radio.utils");
const toggle_controller_1 = require("@/controllers/toggle-controller");
const shared_styles_1 = require("@/stylesheets/shared.styles");
const utils_1 = require("@/utils");
/**
 * 레이블만으로 부족해 가격·배지·설명을 담아야 할 때 쓰는 라디오. 면 전체가 선택 영역이자
 * 선택 상태의 표시면이다. 인디케이터·선택·포커스 규칙은 mm-radio의 공유 스타일을 그대로 조합하고,
 * 그룹·단일 선택은 mm-radio-group이 함께 소유한다.
 */
let RadioCard = class RadioCard extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.name = '';
        this.value = '';
        this.checked = false;
        this.disabled = false;
        // shadow 안에서만 쓰는 label 연결용 id라 호스트의 id와 섞지 않는다.
        this.inputId = (0, utils_1.uniqueId)('radio-card');
        this.toggle = new toggle_controller_1.ToggleController(this, 'checked');
    }
    render() {
        return (0, lit_1.html) `
      ${(0, radio_utils_1.renderRadioInput)(this, this.inputId, this.toggle, (0, lit_1.html) `
          <slot></slot>
        `)}
    `;
    }
};
RadioCard.styles = [shared_styles_1.resetStyles, input_styles_1.visuallyHiddenInputStyles, radio_styles_1.radioStyles, radio_styles_1.radioCardStyles];
__decorate([
    (0, decorators_js_1.property)({ type: String })
], RadioCard.prototype, "name", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], RadioCard.prototype, "value", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], RadioCard.prototype, "checked", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], RadioCard.prototype, "disabled", void 0);
RadioCard = __decorate([
    (0, decorators_js_1.customElement)('mm-radio-card')
], RadioCard);
exports.RadioCard = RadioCard;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmFkaW8tY2FyZC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInJhZGlvLWNhcmQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQXNDO0FBQ3RDLHFEQUEyRDtBQUUzRCx5RUFBa0Y7QUFDbEYseUVBQXFGO0FBQ3JGLHVFQUF3RTtBQUN4RSx1RUFBa0U7QUFDbEUsK0RBQXlEO0FBQ3pELG1DQUFrQztBQUVsQzs7OztHQUlHO0FBRUksSUFBTSxTQUFTLEdBQWYsTUFBTSxTQUFVLFNBQVEsZ0JBQVU7SUFBbEM7O1FBRXVCLFNBQUksR0FBRyxFQUFFLENBQUE7UUFDVCxVQUFLLEdBQUcsRUFBRSxDQUFBO1FBQ1QsWUFBTyxHQUFHLEtBQUssQ0FBQTtRQUNmLGFBQVEsR0FBRyxLQUFLLENBQUE7UUFDN0MsZ0RBQWdEO1FBQ3hDLFlBQU8sR0FBRyxJQUFBLGdCQUFRLEVBQUMsWUFBWSxDQUFDLENBQUE7UUFDaEMsV0FBTSxHQUFnQyxJQUFJLG9DQUFnQixDQUFDLElBQUksRUFBRSxTQUFTLENBQUMsQ0FBQTtJQWNyRixDQUFDO0lBWkMsTUFBTTtRQUNKLE9BQU8sSUFBQSxVQUFJLEVBQUE7UUFDUCxJQUFBLDhCQUFnQixFQUNoQixJQUFJLEVBQ0osSUFBSSxDQUFDLE9BQU8sRUFDWixJQUFJLENBQUMsTUFBTSxFQUNYLElBQUEsVUFBSSxFQUFBOztTQUVILENBQ0Y7S0FDRixDQUFBO0lBQ0gsQ0FBQzs7QUFwQk0sZ0JBQU0sR0FBRyxDQUFDLDJCQUFXLEVBQUUsd0NBQXlCLEVBQUUsMEJBQVcsRUFBRSw4QkFBZSxDQUFDLENBQUE7QUFDMUQ7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDO3VDQUFVO0FBQ1Q7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDO3dDQUFXO0FBQ1Q7SUFBNUIsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE9BQU8sRUFBRSxDQUFDOzBDQUFnQjtBQUNmO0lBQTVCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxPQUFPLEVBQUUsQ0FBQzsyQ0FBaUI7QUFMbEMsU0FBUztJQURyQixJQUFBLDZCQUFhLEVBQUMsZUFBZSxDQUFDO0dBQ2xCLFNBQVMsQ0FzQnJCO0FBdEJZLDhCQUFTIn0=